import React from "react";

const SampleTestCaseTable = ({ question }) => {
  const sampleTestCases =
    question?.test_cases?.filter((test) => test.visibility === "SAMPLE") || [];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {sampleTestCases.map((test, index) => (
        <div
          key={test.id || index}
          className="border border-gray-300 rounded-lg p-4 bg-gray-100"
        >
          <h4 className="font-semibold text-gray-800 mb-3">
            Example {index + 1}
          </h4>

          <div className="space-y-2">
            <div className="flex items-start gap-2">
              <span className="text-sm font-medium text-gray-700">Input:</span>
              <pre className="text-sm font-mono text-gray-800 whitespace-pre-wrap">
                {test.input}
              </pre>
            </div>

            <div className="flex items-start gap-2">
              <span className="text-sm font-medium text-gray-700">Output:</span>
              <pre className="text-sm font-mono text-gray-800 whitespace-pre-wrap">
                {test.output}
              </pre>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SampleTestCaseTable;
